export const INDETERMINATE_GENERATION_SENTINEL = -99;
